import type { CatalogueEntry } from "../types";
import imageLight from "../images/national-localities.light.webp";
import imageDark from "../images/national-localities.dark.webp";

export const entry: CatalogueEntry = {
  slug: "national-localities",
  displayName: `National Localities`,
  datasetProductCode: `GEOSCAPE LOCALITIES`,
  subtitle: `Spatial Representation of Suburbs and Localities`,
  shortDescription: `Localities is a spatial representation of suburbs (urban) and localities (rural) defined by the State and Territory governments of Australia. They represent distinct communities across the country. Localities aggregates the representations unique to each jurisdiction into a consistent, seamless representation of suburb and locality boundaries across Australia.
Localities are integral for addressing and postal distribution purposes.
Localities is designed to meet the needs of organisations that require a geospatial representation of suburb and locality boundaries at both a local and national scale. The attribution provided within Localities allows for the application of the data across a wide range of commercial, government and research uses. Localities can also be used to identify the creation of new suburbs.`,
  metadata: {
    dateAdded: 1630368000000,
    dataType: ["Polygons"],
    totalFeatureCount: 15774,
    updateFrequency: `Quarterly`,
    license: `CC BY 4.0`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/projects/localities_release/en/stable/index.html#document-index`,
  productDescriptionLink: `https://docs.geoscape.com.au/projects/localities_guide/en/stable/index.html`,
  imageLight,
  imageDark,
  searchTags: `National Localities Geoscape Localities Area Identification Communities Community Analysis Local Locality Mapping Regions Spatial Reference Suburban Areas Suburbs`,
  detail: () => import("../details/national-localities").then((m) => m.detail),
};

export default entry;
